import { TextInput } from "@alm/flow-ds/components";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
	setFormId: (value: React.SetStateAction<string | undefined>) => void;
	setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
	formId: string | undefined;
	isValid: boolean;
	onBlur?: () => void;
};

export default ({ setFormId, setIsValid, formId, isValid, onBlur }: Props) => {
	const { t } = useTranslation();

	const [textError, setTextError] = useState<boolean>(false);

	const fid = useMemo(() => formId?.trim(), [formId]);

	/**
	 * Check for textError and call onBlur if defined
	 */
	const handleBlur = useCallback(() => {
		if (!isValid && fid && !textError) {
			setTextError(true);
		} else if ((isValid || !fid) && textError) {
			setTextError(false);
		}
		if (onBlur) onBlur();
	}, [fid, isValid, onBlur, textError]);

	/**
	 * Check if fid is defined and check validation
	 */
	useEffect(() => {
		if (fid) {
			const regexValidation = !/\s/.test(fid);
			regexValidation ? setIsValid(true) : setIsValid(false);
		} else {
			if (isValid) setIsValid(false);
		}
	}, [fid, isValid, setIsValid]);

	return (
		<TextInput
			onChange={e => setFormId(e.target.value)}
			value={formId}
			label={t("formDesigner.labels.formId")}
			required={true}
			id={t("formDesigner.labels.formId")}
			status={textError ? "error" : undefined}
			feedback={
				textError ? t("alerts.errorFormId.description") : undefined
			}
			onBlur={handleBlur}
			hint={t(`formDesigner.elements.common.formId`)}
		/>
	);
};
